import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { Modal } from "@/components/ui";

export const EstimationSummary = ({ state, computed, actions }) => {
  const {
    discountType, setDiscountType, discountValue, setDiscountValue,
    gstType, setGstType, gstValue, setGstValue,
    isLocked, isSaving, estimationStatus,
    showDiscountWarningModal, setShowDiscountWarningModal,
    showRequesterNotesModal, setShowRequesterNotesModal,
    pendingDiscountInfo, canBypassDiscountLimit
  } = state;

  const { subTotal, discountAmount, taxableValue, gstAmount, grandTotal } = computed;
  const { handleAddItem, handlePreview, handlePlaceOrder, proceedToRequesterNotes, submitPendingEstimation, bypassDiscountWarning } = actions;

  const [localRequesterNotes, setLocalRequesterNotes] = useState('');



  return (
    <>
      <div className="flex justify-end mt-4 mx-1">
        <div className="bg-slate-50/50 border border-slate-200 rounded-lg p-4 shadow-sm min-w-[380px]">
          <div className="grid grid-cols-[1fr_auto_100px] items-center gap-x-4 gap-y-3">
            <div className="text-xs font-bold text-slate-500 text-right">Sub Total</div>
            <div className="w-[110px]"></div>
            <div className="text-sm font-bold text-slate-800 text-right">₹{subTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>

            <div className="text-xs font-bold text-slate-500 text-right">
              Discount
            </div>
            <div className="flex items-center gap-1.5 justify-end w-[110px]">
              <div className={`flex items-center bg-slate-100 rounded-sm p-0.5 border border-slate-200 ${isLocked ? 'pointer-events-none opacity-60' : ''}`}>
                <button
                  onClick={() => setDiscountType('%')}
                  className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm transition-all ${discountType === '%' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-400 hover:text-slate-600'}`}
                >
                  %
                </button>
                <button
                  onClick={() => setDiscountType('₹')}
                  className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm transition-all ${discountType === '₹' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-400 hover:text-slate-600'}`}
                >
                  ₹
                </button>
              </div>
              <input
                type="number"
                value={discountValue}
                onChange={e => setDiscountValue(e.target.value)}
                disabled={isLocked}
                className="w-14 h-6 px-1.5 text-xs font-semibold text-slate-700 bg-white border border-slate-200 rounded-sm outline-none text-right focus:border-slate-400 disabled:opacity-60"
                placeholder="0"
              />
            </div>
            <div className="text-sm font-bold text-[#C91D25] text-right">- ₹{discountAmount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>

            {/* Taxable Value — hidden
            <div className="text-xs font-bold text-slate-500 text-right">Taxable Value</div>
            <div className="w-[110px]"></div>
            <div className="text-sm font-bold text-slate-800 text-right">₹{taxableValue.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>
            */}

            {/* GST — hidden
            <div className="text-xs font-bold text-slate-500 text-right">GST</div>
            <div className="flex items-center gap-1.5 justify-end w-[110px]">
              <div className={`flex items-center bg-slate-100 rounded-sm p-0.5 border border-slate-200 ${isLocked ? 'pointer-events-none opacity-60' : ''}`}>
                <button
                  onClick={() => setGstType('%')}
                  className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm transition-all ${gstType === '%' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-400 hover:text-slate-600'}`}
                >
                  %
                </button>
                <button
                  onClick={() => setGstType('₹')}
                  className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm transition-all ${gstType === '₹' ? 'bg-white shadow-sm text-slate-800' : 'text-slate-400 hover:text-slate-600'}`}
                >
                  ₹
                </button>
              </div>
              <input
                type="number"
                value={gstValue}
                onChange={e => setGstValue(e.target.value)}
                disabled={isLocked}
                className="w-14 h-6 px-1.5 text-xs font-semibold text-slate-700 bg-white border border-slate-200 rounded-sm outline-none text-right focus:border-slate-400 disabled:opacity-60"
                placeholder="0"
              />
            </div>
            <div className="text-sm font-bold text-slate-700 text-right">+ ₹{gstAmount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>
            */}

            <div className="col-span-3 h-px bg-slate-200 my-1"></div>

            <div className="text-sm font-bold text-slate-800 text-right py-1">Grand Total</div>
            <div className="w-[110px] py-1"></div>
            <div className="text-base font-bold text-slate-800 text-right py-1">₹{grandTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</div>
          </div>
        </div>
      </div>



      <div className="flex flex-wrap items-center justify-between gap-3 pt-6 mt-6 border-t border-slate-100">
        <div className="w-full 2xl:w-auto flex-1">
          <button
            onClick={handlePlaceOrder}
            disabled={isSaving || ['ORDER_PLACED', 'ORDER_APPROVED', 'SENT_TO_STORE', 'COMPLETED', 'DISPATCHED'].includes(estimationStatus)}
            className="w-full px-4 py-2.5 bg-[#C91D25] text-white rounded-lg text-[13px] font-semibold hover:bg-[#a8161d] active:scale-95 shadow-sm transition-all flex items-center justify-center gap-2 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <ShoppingCart size={16} />
            {['ORDER_PLACED', 'ORDER_APPROVED', 'SENT_TO_STORE', 'COMPLETED', 'DISPATCHED'].includes(estimationStatus) ? 'Order Placed' : 'Place Order'}
          </button>
        </div>

        <div className="flex flex-1 flex-wrap items-center gap-2 w-full 2xl:w-auto justify-end">
          <button
            onClick={handleAddItem}
            disabled={isLocked || isSaving}
            className="flex-1 px-3 py-2.5 bg-white border border-slate-200 rounded-lg text-[13px] font-semibold text-slate-700 hover:bg-slate-50 hover:border-slate-300 active:bg-slate-100 active:scale-95 shadow-sm transition-all flex items-center justify-center gap-1.5 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]"
          >
            <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
            Add another
          </button>
          <button
            onClick={handlePreview}
            disabled={isLocked || isSaving}
            className="flex-1 px-3 py-2.5 bg-[#0f172a] text-white rounded-lg text-[13px] font-semibold hover:bg-black active:bg-slate-900 active:scale-95 shadow-sm transition-all flex items-center justify-center gap-1.5 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]"
          >
            {isSaving ? 'Saving...' : 'Save & Send'}
            {!isSaving && <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>}
          </button>
        </div>
      </div>

      {/* Modals for Discount Approval Flow */}
      <Modal 
        isOpen={showDiscountWarningModal} 
        onClose={() => setShowDiscountWarningModal(false)} 
        title="Discount Limit Exceeded" 
        size="max-w-md"
      >
        <div className="p-2 space-y-4">
          <p className="text-sm text-slate-700">
            You are increasing the discount to <span className="font-bold text-red-600">{pendingDiscountInfo?.effectiveDiscountPercent}%</span>, which is greater than the allowed limit of <span className="font-bold">{pendingDiscountInfo?.limit}%</span>.
          </p>
          
          {canBypassDiscountLimit ? (
            <>
              <p className="text-sm text-slate-700">
                As an authorized user, you can proceed with this discount. Do you want to continue?
              </p>
              <div className="flex justify-end gap-3 mt-4">
                <button 
                  onClick={() => setShowDiscountWarningModal(false)}
                  className="px-4 py-2 text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg"
                >
                  Cancel
                </button>
                <button 
                  onClick={bypassDiscountWarning}
                  className="px-4 py-2 text-sm font-semibold text-white bg-[#0f172a] hover:bg-slate-800 rounded-lg"
                >
                  Proceed Anyway
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="text-sm text-slate-700">
                You need approval to perform this action. Do you want to request approval?
              </p>
              <div className="flex justify-end gap-3 mt-4">
                <button 
                  onClick={() => setShowDiscountWarningModal(false)}
                  className="px-4 py-2 text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg"
                >
                  Cancel
                </button>
                <button 
                  onClick={proceedToRequesterNotes}
                  className="px-4 py-2 text-sm font-semibold text-white bg-[#0f172a] hover:bg-slate-800 rounded-lg"
                >
                  Confirm
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>

      <Modal
        isOpen={showRequesterNotesModal}
        onClose={() => setShowRequesterNotesModal(false)}
        title="Request Discount Approval"
        size="max-w-md"
      >
        <div className="p-2 space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-700 mb-1.5">Requester Notes</label>
            <textarea
              value={localRequesterNotes}
              onChange={(e) => setLocalRequesterNotes(e.target.value)}
              className="w-full h-24 p-2.5 text-sm border border-slate-300 rounded-lg outline-none focus:border-[#C91D25] focus:ring-1 focus:ring-[#C91D25]/20 resize-none"
              placeholder="Please provide a reason for exceeding the discount limit..."
            />
          </div>
          <div className="flex justify-end gap-3 mt-4">
            <button 
              onClick={() => setShowRequesterNotesModal(false)}
              className="px-4 py-2 text-sm font-semibold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg"
            >
              Cancel
            </button>
            <button 
              onClick={() => {
                submitPendingEstimation(localRequesterNotes);
                setLocalRequesterNotes('');
              }}
              disabled={!localRequesterNotes.trim()}
              className="px-4 py-2 text-sm font-semibold text-white bg-[#C91D25] hover:bg-[#a8161d] rounded-lg disabled:opacity-50"
            >
              Submit Request
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
